import { orderBy as _orderBy, omit as _omit, sortBy as _sortBy } from "lodash"
import Constant from "../../../constant"

const convertEvaluationScoreType = (evalScore) => {
   if (evalScore === Constant.EVALUATION_SCORE.ADMINSITRATION_VALUE) {
      return "adminstrationScore"
   } else if (evalScore === Constant.EVALUATION_SCORE.PRICE_VALUE) {
      return "priceScore"
   } else if (evalScore === Constant.EVALUATION_SCORE.TECHNICAL_VALUE) {
      return "technicalScore"
   }
   return null
}

const sortEvaluationScore = (procurement, procurementVendor, procurementVendorItem) => {
   let orderResult
   orderResult = []
   if (procurement.evaluationMethod === Constant.EVALUATION_METHODS.MERIT_POINT) {
      const evalScore = _omit(procurement.evaluationScoring, "_id")
      const sortEvalScore = []
      for (const x in evalScore) {
         sortEvalScore.push([x, evalScore[x]])
      }
      sortEvalScore.sort(function (a, b) {
         return b[1] - a[1]
      })
      const keyScore = convertEvaluationScoreType(sortEvalScore[0][0])

      // totalScore is rounded to 2dp before it is stored, so near-equal offers tie on it; price is the
      // tie-break, and vendors that never offered one rank behind those that did.
      const meritSortFields = ["totalScore", (vendor) => (vendor.lastPrice > 0 ? 0 : 1), "lastPrice", "lastBidTime", keyScore, "name"]
      const meritSortOrders = ["desc", "asc", "asc", "asc", "desc", "asc"]

      const _procurementVendorItem = procurementVendorItem.map((vendorItem) => {
         const res = procurementVendor.find((vendor) => vendorItem.procurementVendorId === vendor._id)
         vendorItem.lastBidTime = res.lastBidTime
         return vendorItem
      })

      // find vendor with minus saving
      const minusSavingVendors = _procurementVendorItem.filter((vendor) => vendor.saving < 0)
      if (procurementVendorItem.length > 2) {
         // do this condition only if auction participant is more than 2 vendors
         // this case is for closed auction

         if (minusSavingVendors.length > 0) {
            // 1. filter and order vendors without minus saving
            const orderVendorWithoutMinusSaving = _orderBy(_procurementVendorItem, meritSortFields, meritSortOrders).filter((vendor) => vendor.saving >= 0)

            // order only for minus saving vendor
            const orderVendorMinusSaving = _orderBy(minusSavingVendors, meritSortFields, meritSortOrders)

            orderResult = [...orderVendorWithoutMinusSaving, ...orderVendorMinusSaving]
         } else {
            orderResult = _orderBy(_procurementVendorItem, meritSortFields, meritSortOrders)
         }
      } else {
         if (minusSavingVendors.length > 0) {
            const vendorWithoutMinusSaving = _procurementVendorItem.filter((vendor) => vendor.saving >= 0)

            // always place vendor without minus saving on top
            orderResult = [...vendorWithoutMinusSaving, ...minusSavingVendors]
         } else {
            orderResult = _orderBy(_procurementVendorItem, meritSortFields, meritSortOrders)
         }
      }
   } else if (procurement.evaluationMethod !== Constant.EVALUATION_METHODS.MERIT_POINT) {
      const _procurementVendorItem = procurementVendorItem.map((vendorItem) => {
         const res = procurementVendor.find((vendor) => vendorItem.procurementVendorId === vendor._id)
         vendorItem.lastBidTime = res.lastBidTime
         return vendorItem
      })

      const _procurementVendor = _procurementVendorItem.map((vendor) => {
         if (vendor.lastBidTime === null) {
            vendor.lastBidTime = new Date(9999, 11, 31, 23, 59, 59).getTime()
         } else {
            vendor.lastBidTime = new Date(vendor.lastBidTime).getTime()
         }
         return vendor
      })

      const includeZeroBid = _procurementVendor.find((v) => v.lastPrice === 0)
      const bidOverOneVendor = _procurementVendor.filter((v) => v.lastPrice > 0).length > 1
      if (bidOverOneVendor && includeZeroBid) {
         // find vendor with minus saving
         const minusSavingVendors = _procurementVendor.filter((vendor) => vendor.saving < 0)
         if (procurementVendorItem.length > 2) {
            if (minusSavingVendors.length > 0) {
               const vendorWithoutMinusSavingAndZeroBid = _procurementVendor.filter(
                  (v) => v.saving >= 0 && v.lastPrice > 0,
               )
               const orderVendorWithoutMinusSavingAndZeroBid = _orderBy(
                  vendorWithoutMinusSavingAndZeroBid,
                  ["lastPrice", "lastBidTime", "name"],
                  ["asc", "asc", "asc"],
               )
               const _zeroBid = _procurementVendor.filter((v) => v.lastPrice == 0)
               const orderVendorMinusSaving = _orderBy(minusSavingVendors, ["lastPrice", "lastBidTime", "name"], ["asc", "asc", "asc"])
               orderResult = [...orderVendorWithoutMinusSavingAndZeroBid, ..._zeroBid, ...orderVendorMinusSaving]
            } else {
               // sort from lowest last price & remove vendor with 0 last price
               const newOrderResult = _orderBy(_procurementVendor, ["lastPrice", "name"], ["asc", "asc"]).filter(
                  (v) => v.lastPrice > 0,
               )
               const _noZeroBid = _orderBy(newOrderResult, ["lastPrice", "lastBidTime", "name"], ["asc", "asc", "asc"])
               const _zeroBid = _procurementVendor.filter((v) => v.lastPrice == 0)
               orderResult = [..._noZeroBid, ..._zeroBid]
            }
         } else {
            orderResult = _orderBy(_procurementVendor, ["saving", "lastBidTime", "name"], ["desc", "asc", "asc"])
         }
      } else if (includeZeroBid) {
         const minusSavingVendors = _procurementVendor.filter((vendor) => vendor.saving < 0)
         if (procurementVendor.length > 2) {
            if (minusSavingVendors.length > 0) {
               const orderVendorWithoutMinusSaving = _orderBy(
                  _procurementVendor,
                  ["lastPrice", "lastBIdTime", "name"],
                  ["asc", "asc", "asc"],
               ).filter((v) => v.saving >= 0)

               const orderVendorMinusSaving = _orderBy(minusSavingVendors, ["lastPrice", "lastBidTime", "name"], ["asc", "asc", "asc"])
               orderResult = [...orderVendorWithoutMinusSaving, ...orderVendorMinusSaving]
            } else {
               orderResult = _orderBy(
                  _procurementVendor,
                  ["saving", "lastPrice", "lastBidTime", "name"],
                  ["desc", "asc", "asc", "asc"],
               )
            }
         } else {
            if (minusSavingVendors.length > 0) {
               const vendorWithoutMinusSaving = _procurementVendor.filter((vendor) => vendor.saving >= 0)
               orderResult = [...vendorWithoutMinusSaving, ...minusSavingVendors]
            } else {
               orderResult = _orderBy(
                  _procurementVendor,
                  ["saving", "lastPrice", "lastBidTime", "name"],
                  ["desc", "asc", "asc", "asc"],
               )
            }
         }
      } else {
         orderResult = _orderBy(_procurementVendor, ["saving", "lastPrice", "lastBidTime", "name"], ["desc", "asc", "asc", "asc"])
      }
   }
   // Quality System ranks on technical score alone, so nothing above sinks an over-ceiling bid.
   return [...orderResult.filter((v) => !v.isAboveCeiling), ...orderResult.filter((v) => v.isAboveCeiling)]
}

// A vendor item carries no rank of its own; it inherits its procurement vendor's Price Evaluation rank.
const priceEvaluationRankOf = (vendorItem, procurementVendors) =>
   vendorItem?.priceEvaluationRank ??
   procurementVendors?.find((vendor) => vendor._id === vendorItem?.procurementVendorId)?.priceEvaluationRank

// Returned items carry the inherited rank, so displayRank works on them without the vendor list.
const sortByPriceEvaluationRank = (vendorItems, procurementVendors) => {
   if (!vendorItems?.length) return vendorItems
   const ranked = vendorItems.map((vendorItem) => ({
      ...vendorItem,
      priceEvaluationRank: priceEvaluationRankOf(vendorItem, procurementVendors),
   }))
   if (!ranked.every((vendorItem) => typeof vendorItem.priceEvaluationRank === "number")) return vendorItems
   return _sortBy(ranked, "priceEvaluationRank")
}

const displayRank = (vendorItem, index, procurementVendors) =>
   priceEvaluationRankOf(vendorItem, procurementVendors) ?? index + 1

const ProcurementVendorItemUtil = {
   sortEvaluationScore,
   sortByPriceEvaluationRank,
   displayRank,
}

export { sortByPriceEvaluationRank, displayRank }

export default ProcurementVendorItemUtil
